<template>
  <vs-card v-if="department != ''" class="card-con">
    <div slot="header">
      <h3>
        {{
          department.charAt(0).toUpperCase() + department.slice(1)
        }}
        Department
      </h3>
    </div>
    <div class="layout-card-employee">
      <div
        v-for="item in $store.getters['i_APC/department'][index]"
        :key="item"
        class="employee-box"
      >
        <CardEmployee :item="item" />
      </div>
    </div>
  </vs-card>
</template>

<script>
import CardEmployee from "./components/RM/CardEmployee.vue";

export default {
  components: {
    CardEmployee,
  },
  data() {
    return {
      department: "",
      index: 0,
    };
  },
  mounted() {
    console.log(this.$route.query.department);
    this.department = this.$route.query.department;
    this.index = this.$store.getters["i_APC/dept_name"].indexOf(
      this.department
    );
    console.log(this.department,this.index);
  },
};
</script>

<style lang="scss" scoped>
.card-con {
  border-radius: 20px;
}
.layout-card-employee {
  display: flex;
  flex-wrap: wrap;
  //   justify-content: space-between;
  gap: 10px;
  overflow: auto;
  height: 100%;
  .employee-box{
    width: 200px;
  }
}
</style>